import { SurveyState } from "@/redux/survey.types"
import { createSelector } from "@reduxjs/toolkit"

const surveyState = (state: { survey: SurveyState }) => state

export const selectSurvey = createSelector(surveyState, (state) => state.survey)
